// Turn the raw operations[] array into boolean permission flags.
// delete → canDelete, update → canEdit, read → canPreview + canView.

export type OperationCheck = {
	readonly operation: string | null;
} | null;

export type AttachmentPermissions = {
	hasDeletePermission: boolean;
	hasEditPermission: boolean;
	hasPreviewPermission: boolean;
	hasViewPermission: boolean;
};

// Returns all-false if operations is null/undefined.
export const extractPermissions = (
	ops: ReadonlyArray<OperationCheck> | null | undefined,
): AttachmentPermissions => {
	const has = (op: string): boolean => !!ops?.some((o) => o?.operation === op);
	return {
		hasDeletePermission: has('delete'),
		hasEditPermission: has('update'),
		hasPreviewPermission: has('read'),
		hasViewPermission: has('read'),
	};
};
